/* eslint-disable */
import axios from 'axios'
import { store, common } from '@/common/index'
import $qs from 'qs'
import $Cookies from 'js-cookie'
import Vue from 'vue';

import { Loading } from 'element-ui'
 
// 创建Loading实例
let loadingInstance = null


//请求拦截
axios.interceptors.request.use(config => {
    //可将store导入并配置请求token
    // config.headers.token = store.state.token
    if (!$Cookies.get('UUID') && !window.localStorage.getItem('UUID')) store.commit('LOGIN_OUT')
    // 显示Loading
    loadingInstance = Loading.service({ fullscreen: true, customClass:'commonLoading' })
    return config
  }, err => {
    return Promise.resolve(err)
  });
//响应拦截
axios.interceptors.response.use(resp => {
    // if (resp.data.status === 99999&& !resp.data.success && messageFlag) {

    //   // Message.error({
    //   //   message: resp.data.message,
    //   //   showClose: true,
    //   //   duration: 0
    //   // });
    //   this.$vux.toast.show({
    //     text: resp.data.message,
    //     type:'warn',
    //   })
    //   messageFlag = false;
    //   setTimeout(() => {
    //     messageFlag = true
    //   },2000)
    // }
    if (resp.data.code === 99999) {
      // Vue.$vux.toast.show({
      //       text: resp.data.message || resp.data.msg,
      //       type:'warn',
      //     })
      // let url = window.location.href;
      // url = url.slice(0,url.indexOf('#'))+'api/game/blockTemplate'+ `?blockMsg=${resp.data.message || resp.data.msg}`
      // location.replace(url)
      // location.hash = ''
      let timer = setTimeout(function() {
        location.hash = `/404?err=${resp.data.message || resp.data.msg}`
        clearTimeout(timer)
      }, 1500)
      // Router.replace({path:'/404',query:{
      //   err:resp.data.message || resp.data.msg
      // }})
    }
    // 隐藏Loading
    if (loadingInstance) {
      loadingInstance.close()
    }
    return resp
  }, error => {
    if (error.response) {
      let status = error.response.status;
      // 根据状态码，返回错误类型
      error.response.statusText = trans(status);
      if (status === 701 || status === 706 || status === 707) {
        // store.commit(types.LOGOUT)
        // router.push({path: '/passport/login'})
      } else if (status >= 500) {
        let msg = trans(status);
        this.$vux.toast.show({
          text: msg,
          type: 'warn',
        })
        // store.commit(types.LOGOUT)
        // router.replace({path: '/error/' + status})
      } else if (status === 403) {
        store.commit('LOGIN_OUT');
        $Cookies.remove('UUID');
        // router.push({path: '/login'})
      }
      // 隐藏Loading
      if (loadingInstance) {
        loadingInstance.close()
      }
      //抛出错误给链式catch()
      return Promise.reject(error)
    }
  }
);

//判断请求错误类型
function trans(status) {
  switch (status) {
    case 400:
      return '错误的请求';
    case 407:
      return '资源未授权';
    case 403:
      return '登录过期';
    case 404:
      return '资源不存在';
    case 500:
      return '服务出错了';
    case 504:
      return '服务出错了';
    case 502:
      return '服务器暂时不可用';
    case 503:
      return '服务忙';
    case 701: // 无效的授权
      return '登录已过期';
    case 702:
      return '账号未激活';
    case 703:
      return '账号被冻结';
    case 704:
      return '账号已停用';
    case 705:
      return '账号审核失败';
    case 706:
      return '账号被踢出';
    case 707:
      return '非法的授权';
  }
}

/** 判断参数元素的类型
 *  ({}).toString.call(ele) ===> [object type],
 *  str.match(regexp) ===> 返回array,(如果字符串匹配到了表达式，会返回一个数组，
 *  数组的第一项是进行匹配完整的字符串===>' type'    ，之后的项是用圆括号捕获的结果===>'type' 。如果没有匹配到，返回null);
 *  toLowerCase() 全部转换为小写*/
function toType(ele) {
  return ({}).toString.call(ele).match(/\s([A-Za-z]+)/)[1].toLowerCase()
}
/** 过滤参数
 * 判断参数的类型， 并去除每一项值字符串前后的空格*/
function filterNull(o) {
  for (let key in o) {
    if (o[key] === null) {
      delete o[key]
    }
    if (toType(o[key]) === 'string') {
      // o[key] = o[key].trim()
      o[key] = o[key].replace(/(^\s*)|(\s*$)/g, "");
    } else if (toType(o[key]) === 'object' || toType(o[key]) === 'array') {
      o[key] = filterNull(o[key])
    } else if (toType(o[key]) === 'number') {
      o[key] = Number(o[key])
    }
  }
  return o
}

/** 参数加密**/
function encrypt(o){
  let newparams = {
    'encryptParam':{}
  }
  if(o['UUID']) newparams['UUID'] =o['UUID'];
  
  newparams['times_tamp'] = o['times_tamp'];
  for(let key in o){
    if(key !== 'UUID' || key !== 'times_tamp'){
      newparams['encryptParam'][key] = o[key]
    }
  }
  
  console.log(process.env.NODE_ENV)
  // console.log(newparams)
  // if(process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'production'){
  //   function _0x1507(_0x2a3c77,_0x5b4513){var _0x150763=_0x5b45();_0x1507=function(_0x33bb4c,_0x5b07fd){_0x33bb4c=_0x33bb4c-0x0;var _0x1d9134=_0x150763[_0x33bb4c];return _0x1d9134;};return _0x1507(_0x2a3c77,_0x5b4513);}function _0x131d4(_0x2b81fb,_0x42ebc9,_0x560a58,_0xf9df5f,_0x34341d){return _0x1507(_0x560a58- -0x3db,_0x42ebc9);}function _0x5b45(){var _0x1ae685=["\u0033\u0035\u0030\u0038\u0032\u007a\u0077\u006b\u004e\u0065\u0052","YfArPu427885".split("").reverse().join(""),"EqMIXg40131".split("").reverse().join(""),"TjVYpL5496923".split("").reverse().join(""),"GpdAWm4725621".split("").reverse().join(""),"UdBCZl184542".split("").reverse().join(""),"553E7DC7391A134BDF1A29B99F37E346".split("").reverse().join(""),"\u0033\u0030\u0031\u0037\u0031\u0034\u0037\u0041\u0066\u0059\u0047\u0068\u0067","SEAyBtpyrcne".split("").reverse().join(""),"yfignirts".split("").reverse().join(""),"cxeICO0322".split("").reverse().join(""),"GFlrlq6".split("").reverse().join(""),"rcJXcU61".split("").reverse().join(""),"\u0065\u006e\u0063\u0072\u0079\u0070\u0074\u0050\u0061\u0072\u0061\u006d"];_0x5b45=function(){return _0x1ae685;};return _0x5b45();}(function(_0x490e8f,_0x3d3d0f){function _0x22e907(_0x5189a6,_0x180dd1,_0x12d1c3,_0x1458a4,_0x4e1d99){return _0x1507(_0x180dd1-0x153,_0x12d1c3);}function _0x430b7d(_0x20f743,_0x581af0,_0x21e969,_0x31d1f3,_0x18cf0d){return _0x1507(_0x31d1f3-0x35d,_0x18cf0d);}var _0x48c080=_0x490e8f();function _0x5ed933(_0x571f70,_0x14297f,_0x76e90d,_0x47523b,_0x3ecc6e){return _0x1507(_0x47523b- -0x3b0,_0x3ecc6e);}function _0x30aae7(_0x5260b1,_0x22bb2f,_0x10b151,_0x11873f,_0x3cf38a){return _0x1507(_0x3cf38a- -0x229,_0x11873f);}function _0x3cd3ad(_0x46e1db,_0x531590,_0x215d6a,_0x331c5c,_0x515d16){return _0x1507(_0x531590- -0x3e8,_0x331c5c);}while(!![]){try{var _0x563def=-parseInt(_0x3cd3ad(-0x3ea,-0x3e4,-0x3e7,-0x3de,-0x3ea))/0x1*(-parseInt(_0x3cd3ad(-0x3dd,-0x3de,-0x3db,-0x3df,-0x3e5))/0x2)+-parseInt(_0x3cd3ad(-0x3e7,-0x3e7,-0x3eb,-0x3ea,-0x3e6))/0x3+parseInt(_0x30aae7(-0x22a,-0x22a,-0x22f,-0x229,-0x229))/0x4+-parseInt(_0x3cd3ad(-0x3e0,-0x3e6,-0x3e4,-0x3e3,-0x3ec))/0x5+parseInt(_0x30aae7(-0x220,-0x22c,-0x229,-0x220,-0x226))/0x6+parseInt(_0x22e907(0x160,0x159,0x152,0x153,0x15e))/0x7*(-parseInt(_0x430b7d(0x36c,0x366,0x369,0x368,0x366))/0x8)+-parseInt(_0x3cd3ad(-0x3db,-0x3db,-0x3db,-0x3db,-0x3d6))/0x9*(-parseInt(_0x430b7d(0x36a,0x364,0x369,0x366,0x362))/0xa);if(_0x563def===_0x3d3d0f){break;}else{_0x48c080["\u0070\u0075\u0073\u0068"](_0x48c080["\u0073\u0068\u0069\u0066\u0074"]());}}catch(_0xac690d){_0x48c080["\u0070\u0075\u0073\u0068"](_0x48c080["\u0073\u0068\u0069\u0066\u0074"]());}}})(_0x5b45,0x6aec6);function _0x4612a6(_0x2e3ae4,_0x1af805,_0x21ff4a,_0x5b0662,_0x434c9c){return _0x1507(_0x5b0662- -0x1,_0x1af805);}function _0xa773d6(_0x1a5220,_0x1cb288,_0x87dcc9,_0x87a237,_0x25e0fb){return _0x1507(_0x1cb288-0x2a1,_0x25e0fb);}newparams[_0xa773d6(0x2ac,0x2ad,0x2ab,0x2b0,0x2a9)]=common["\u0065\u006e\u0063\u0072\u0079\u0070\u0074\u0042\u0079\u0041\u0045\u0053"](JSON["\u0073\u0074\u0072\u0069\u006e\u0067\u0069\u0066\u0079"](newparams[_0xa773d6(0x2b4,0x2ad,0x2a7,0x2b3,0x2a6)]),_0x4612a6(0x7,0x9,0x6,0x4,0x4));
  // }else{
  //   function _0x4893(_0x1c03e5,_0x4b9f92){var _0x14e98d=_0x4b9f();_0x4893=function(_0x11f3a5,_0x59c8f1){_0x11f3a5=_0x11f3a5-0x0;var _0xd19d34=_0x14e98d[_0x11f3a5];if(_0x4893["\u004e\u0068\u007a\u006b\u0066\u0053"]===undefined){var _0xabbae8=function(_0x2613bd){var _0x27363e="=/+9876543210ZYXWVUTSRQPONMLKJIHGFEDCBAzyxwvutsrqponmlkjihgfedcba".split("").reverse().join("");var _0x2916e8="".split("").reverse().join("");var _0x36c572="";for(var _0x288e55=0x0,_0x27aa5c,_0x1d5ebe,_0x329eab=0x0;_0x1d5ebe=_0x2613bd["\u0063\u0068\u0061\u0072\u0041\u0074"](_0x329eab++);~_0x1d5ebe&&(_0x27aa5c=_0x288e55%0x4?_0x27aa5c*0x40+_0x1d5ebe:_0x1d5ebe,_0x288e55++%0x4)?_0x2916e8+=String["\u0066\u0072\u006f\u006d\u0043\u0068\u0061\u0072\u0043\u006f\u0064\u0065"](0xff&_0x27aa5c>>(-0x2*_0x288e55&0x6)):0x0){_0x1d5ebe=_0x27363e["\u0069\u006e\u0064\u0065\u0078\u004f\u0066"](_0x1d5ebe);}for(var _0x251958=0x0,_0x6a403d=_0x2916e8["\u006c\u0065\u006e\u0067\u0074\u0068"];_0x251958<_0x6a403d;_0x251958++){_0x36c572+="\u0025"+("00".split("").reverse().join("")+_0x2916e8["\u0063\u0068\u0061\u0072\u0043\u006f\u0064\u0065\u0041\u0074"](_0x251958)["\u0074\u006f\u0053\u0074\u0072\u0069\u006e\u0067"](0x10))["\u0073\u006c\u0069\u0063\u0065"](-0x2);}return decodeURIComponent(_0x36c572);};var _0x469c89=function(_0x35dc3d,_0x38c32f){var _0x518811=[],_0x662f43=0x0,_0x301cc6,_0x2433af="".split("").reverse().join("");_0x35dc3d=_0xabbae8(_0x35dc3d);var _0x205176;for(_0x205176=0x0;_0x205176<0x100;_0x205176++){_0x518811[_0x205176]=_0x205176;}for(_0x205176=0x0;_0x205176<0x100;_0x205176++){_0x662f43=(_0x662f43+_0x518811[_0x205176]+_0x38c32f["\u0063\u0068\u0061\u0072\u0043\u006f\u0064\u0065\u0041\u0074"](_0x205176%_0x38c32f["\u006c\u0065\u006e\u0067\u0074\u0068"]))%0x100;_0x301cc6=_0x518811[_0x205176];_0x518811[_0x205176]=_0x518811[_0x662f43];_0x518811[_0x662f43]=_0x301cc6;}_0x205176=0x0;_0x662f43=0x0;for(var _0x9e158d=0x0;_0x9e158d<_0x35dc3d["\u006c\u0065\u006e\u0067\u0074\u0068"];_0x9e158d++){_0x205176=(_0x205176+0x1)%0x100;_0x662f43=(_0x662f43+_0x518811[_0x205176])%0x100;_0x301cc6=_0x518811[_0x205176];_0x518811[_0x205176]=_0x518811[_0x662f43];_0x518811[_0x662f43]=_0x301cc6;_0x2433af+=String["\u0066\u0072\u006f\u006d\u0043\u0068\u0061\u0072\u0043\u006f\u0064\u0065"](_0x35dc3d["\u0063\u0068\u0061\u0072\u0043\u006f\u0064\u0065\u0041\u0074"](_0x9e158d)^_0x518811[(_0x518811[_0x205176]+_0x518811[_0x662f43])%0x100]);}return _0x2433af;};_0x4893["\u006a\u005a\u0070\u0050\u0043\u0072"]=_0x469c89;_0x1c03e5=arguments;_0x4893["\u004e\u0068\u007a\u006b\u0066\u0053"]=!![];}var _0x2c22dc=_0x14e98d[0x0];var _0x14eaf8=_0x11f3a5+_0x2c22dc;var _0x4893b9=_0x1c03e5[_0x14eaf8];if(!_0x4893b9){if(_0x4893["\u0057\u0056\u0072\u006f\u0078\u0045"]===undefined){_0x4893["\u0057\u0056\u0072\u006f\u0078\u0045"]=!![];}_0xd19d34=_0x4893["\u006a\u005a\u0070\u0050\u0043\u0072"](_0xd19d34,_0x59c8f1);_0x1c03e5[_0x14eaf8]=_0xd19d34;}else{_0xd19d34=_0x4893b9;}return _0xd19d34;};return _0x4893(_0x1c03e5,_0x4b9f92);}function _0x14e9(_0x1c03e5,_0x4b9f92){var _0x14e98d=_0x4b9f();_0x14e9=function(_0x11f3a5,_0x59c8f1){_0x11f3a5=_0x11f3a5-0x0;var _0xd19d34=_0x14e98d[_0x11f3a5];if(_0x14e9["\u0043\u0066\u0048\u0066\u0050\u006e"]===undefined){var _0xabbae8=function(_0x469c89){var _0x2613bd="=/+9876543210ZYXWVUTSRQPONMLKJIHGFEDCBAzyxwvutsrqponmlkjihgfedcba".split("").reverse().join("");var _0x27363e="".split("").reverse().join("");var _0x2916e8="".split("").reverse().join("");for(var _0x36c572=0x0,_0x288e55,_0x27aa5c,_0x1d5ebe=0x0;_0x27aa5c=_0x469c89["\u0063\u0068\u0061\u0072\u0041\u0074"](_0x1d5ebe++);~_0x27aa5c&&(_0x288e55=_0x36c572%0x4?_0x288e55*0x40+_0x27aa5c:_0x27aa5c,_0x36c572++%0x4)?_0x27363e+=String["\u0066\u0072\u006f\u006d\u0043\u0068\u0061\u0072\u0043\u006f\u0064\u0065"](0xff&_0x288e55>>(-0x2*_0x36c572&0x6)):0x0){_0x27aa5c=_0x2613bd["\u0069\u006e\u0064\u0065\u0078\u004f\u0066"](_0x27aa5c);}for(var _0x329eab=0x0,_0x251958=_0x27363e["\u006c\u0065\u006e\u0067\u0074\u0068"];_0x329eab<_0x251958;_0x329eab++){_0x2916e8+="\u0025"+("00".split("").reverse().join("")+_0x27363e["\u0063\u0068\u0061\u0072\u0043\u006f\u0064\u0065\u0041\u0074"](_0x329eab)["\u0074\u006f\u0053\u0074\u0072\u0069\u006e\u0067"](0x10))["\u0073\u006c\u0069\u0063\u0065"](-0x2);}return decodeURIComponent(_0x2916e8);};_0x14e9["\u0050\u0057\u005a\u006a\u004a\u0078"]=_0xabbae8;_0x1c03e5=arguments;_0x14e9["\u0043\u0066\u0048\u0066\u0050\u006e"]=!![];}var _0x2c22dc=_0x14e98d[0x0];var _0x14eaf8=_0x11f3a5+_0x2c22dc;var _0x4893b9=_0x1c03e5[_0x14eaf8];if(!_0x4893b9){_0xd19d34=_0x14e9["\u0050\u0057\u005a\u006a\u004a\u0078"](_0xd19d34);_0x1c03e5[_0x14eaf8]=_0xd19d34;}else{_0xd19d34=_0x4893b9;}return _0xd19d34;};return _0x14e9(_0x1c03e5,_0x4b9f92);}(function(_0x33ca55,_0x3f1191){function _0x4df84e(_0x1ed2a1,_0x359e83,_0xdc958d,_0x3d8d57,_0x3d2e70){return _0x4893(_0x359e83-0xa4,_0xdc958d);}function _0x21c666(_0x25c0d8,_0x40dcdc,_0x40e540,_0x21424e,_0x10aacd){return _0x4893(_0x10aacd- -0x175,_0x40e540);}function _0x40a06e(_0x56081f,_0x4d11df,_0x59039f,_0x2dae7b,_0x495353){return _0x14e9(_0x2dae7b- -0x16c,_0x4d11df);}function _0xb603a4(_0x43aeb3,_0x21f2b8,_0x14805,_0x116e2d,_0x10cd64){return _0x4893(_0x21f2b8- -0x27e,_0x43aeb3);}function _0x22fef2(_0x431c93,_0x116324,_0x366d9b,_0x40d1f8,_0x12e9f9){return _0x4893(_0x40d1f8- -0x1f,_0x116324);}function _0x2a7e3d(_0x569fc7,_0x10a2d4,_0x4faedd,_0x2621a6,_0x1e0015){return _0x14e9(_0x569fc7- -0x33d,_0x10a2d4);}function _0x5b355c(_0x14890a,_0x2ed6f5,_0x5cda04,_0x5c003e,_0x1cfd42){return _0x4893(_0x14890a- -0x3bc,_0x1cfd42);}var _0x4958ad=_0x33ca55();function _0x4cf826(_0x39be15,_0x4de7ae,_0x3cc497,_0x40cae2,_0x390320){return _0x14e9(_0x3cc497-0x380,_0x390320);}function _0x2aa7e4(_0x3c9baa,_0xa1503c,_0x4dddb1,_0xe5a1b0,_0x2ac5cd){return _0x14e9(_0x3c9baa- -0x23,_0x4dddb1);}function _0x20e900(_0xe096ba,_0x3f54f8,_0x3da8fd,_0x3b778f,_0x25a7b2){return _0x14e9(_0x3b778f- -0x1b1,_0x3da8fd);}while(!![]){try{var _0x3e9da5=-parseInt(_0x20e900(-0x1a2,-0x1ae,-0x1a2,-0x1ac,-0x1a3))/0x1*(parseInt(_0xb603a4("\u006d\u0048\u0076\u006b",-0x27b,-0x281,-0x284,-0x276))/0x2)+-parseInt(_0x22fef2(-0x24,"\u0049\u0079\u0072\u004d",-0x11,-0x18,-0xd))/0x3*(-parseInt(_0x4df84e(0xb3,0xb4,"Sy03".split("").reverse().join(""),0xb5,0xbc))/0x4)+-parseInt(_0x4cf826(0x391,0x394,0x388,0x37d,0x386))/0x5+-parseInt(_0x20e900(-0x1ad,-0x1b0,-0x1ab,-0x1a8,-0x19f))/0x6+-parseInt(_0x40a06e(-0x167,-0x170,-0x167,-0x16a,-0x160))/0x7*(-parseInt(_0x2aa7e4(-0xf,-0x1a,-0x19,-0x12,-0xb))/0x8)+-parseInt(_0xb603a4("\u0054\u0040\u006b\u004c",-0x278,-0x274,-0x27f,-0x275))/0x9*(-parseInt(_0x5b355c(-0x3a6,-0x3aa,-0x3a6,-0x3a1,"\u0036\u0034\u006b\u0079"))/0xa)+parseInt(_0x4df84e(0xb4,0xb9,"$[nH".split("").reverse().join(""),0xb7,0xc5))/0xb*(parseInt(_0x40a06e(-0x159,-0x15d,-0x151,-0x155,-0x156))/0xc);if(_0x3e9da5===_0x3f1191){break;}else{_0x4958ad["\u0070\u0075\u0073\u0068"](_0x4958ad["\u0073\u0068\u0069\u0066\u0074"]());}}catch(_0x2b31ea){_0x4958ad["\u0070\u0075\u0073\u0068"](_0x4958ad["\u0073\u0068\u0069\u0066\u0074"]());}}})(_0x4b9f,0x73ca6);function _0x12a948(_0x5b43fc,_0x3eeebd,_0xbbcb06,_0x3df101,_0x7006ce){return _0x14e9(_0x7006ce-0x35b,_0xbbcb06);}function _0x4b9f(){var _0x4f4a65=["i5WKyOWGk8FxTPW".split("").reverse().join(""),"aBRomz5oCRcJtihoml".split("").reverse().join(""),"fjurZPvw2mJn2etm".split("").reverse().join(""),"\u006d\u004a\u006a\u0049\u007a\u0030\u0066\u006d\u0073\u004e\u004f","5kmSct4WJS7WCP6WckCNchYGd7RW".split("").reverse().join(""),"3eRWEKhScZhe".split("").reverse().join(""),"GQdVfJcBOWNo8LcxaaQGIw".split("").reverse().join(""),"z0fs3rde9rxCIoSk".split("").reverse().join(""),"\u006e\u0074\u0061\u0030\u0072\u0077\u0050\u0041\u0076\u0075\u0058\u0073","3o8rsoSGcBtmbkCB".split("").reverse().join(""),"\u0057\u0051\u0042\u0063\u004e\u0038\u006b\u0047\u0079\u0038\u006b\u0048\u0057\u0035\u0079\u0065\u0057\u0050\u0033\u0064\u0054\u0038\u006f\u0067","qEAXwEoHfn2mJnYato".split("").reverse().join(""),"\u006e\u004a\u006a\u0067\u0072\u0064\u004b\u0031\u0071\u0075\u007a\u0067\u0071\u005a\u0071\u0031\u006d\u004b\u0071\u0035\u006e\u0030\u006d\u0059\u006d\u005a\u0065\u0033\u0072\u0074\u004b\u0032\u006e\u0064\u0065\u005a\u006f\u0065\u0069\u0031\u0071\u004a\u0071","ePW15QWmeOWlkmlskSn".split("").reverse().join(""),"GwwXLeurndn2mtm".split("").reverse().join(""),"8W3nP0OWsoCq".split("").reverse().join(""),"tvuq5jeDWLNCJ5wz".split("").reverse().join(""),"\u006d\u0074\u0047\u0059\u006d\u004a\u0065\u0035\u0077\u004e\u006a\u0076\u0074\u004c\u0044\u004f","BkmGc7OW3j2HdZ4WooCwyqRW".split("").reverse().join(""),"/bfp1jPW0K6W".split("").reverse().join(""),"asJretj9em3mZm1atm".split("").reverse().join(""),"\u006e\u0064\u0047\u0035\u006f\u0074\u0043\u0035\u006d\u004b\u0044\u0071\u007a\u0065\u0039\u006d\u007a\u0057","qj7kmjao8vYDahzX7W".split("").reverse().join(""),"\u007a\u0077\u0035\u004a\u0043\u004e\u004c\u0057\u0044\u0066\u0062\u0048\u0043\u004d\u0066\u0054"];_0x4b9f=function(){return _0x4f4a65;};return _0x4b9f();}function _0x560ac5(_0x3ce69b,_0x4285e1,_0x2af368,_0x21b2f8,_0x24e414){return _0x14e9(_0x4285e1- -0x3aa,_0x2af368);}function _0x898f78(_0x193b74,_0x2b44f4,_0x45c474,_0x230fc1,_0x29f58b){return _0x14e9(_0x230fc1-0x41,_0x193b74);}newparams[_0x898f78(0x50,0x4a,0x4a,0x4c,0x4e)]=common["\u0065\u006e\u0063\u0072\u0079\u0070\u0074\u0042\u0079\u0041\u0045\u0053"](JSON["\u0073\u0074\u0072\u0069\u006e\u0067\u0069\u0066\u0079"](newparams[_0x898f78(0x4c,0x54,0x4d,0x4c,0x55)]),_0x12a948(0x350,0x358,0x35f,0x360,0x35b));
  // }
  newparams['\x65\x6e\x63\x72\x79\x70\x74\x50\x61\x72\x61\x6d'] = common["\x65\x6e\x63\x72\x79\x70\x74\x42\x79\x41\x45\x53"](JSON["\x73\x74\x72\x69\x6e\x67\x69\x66\x79"](newparams['\x65\x6e\x63\x72\x79\x70\x74\x50\x61\x72\x61\x6d']),'\x30\x44\x34\x33\x46\x35\x45\x30\x37\x31\x42\x38\x30\x41\x42\x44\x36\x41\x42\x32\x44\x41\x45\x35\x30\x45\x43\x46\x30\x33\x39\x44')

  return newparams
}

let base = '';

function apiAxios(method, url, params = {}, callback = null, failure = null) {
  return Promise.resolve().then(() => {
    let lang = $Cookies.get('lang')
    params['appVersion'] = '1.0';
    params['appType'] = 'h5';
    if (params.UUID || $Cookies.get('UUID') || window.localStorage.getItem('UUID')) {
      params['UUID'] = params.UUID || $Cookies.get('UUID') || window.localStorage.getItem('UUID');
    }
    if (!params.lang) params['lang'] = lang || 'en_US';
    params['times_tamp'] = new Date().getTime();
    //过滤参数，取消所有用户输入的前后空格
    if (params) {
      params = filterNull(params);
      params = encrypt(params)
      if (method === 'POST') {
        params = $qs.stringify(params)
      }
    }
    // `data`是要作为请求主体发送的数据
    // 仅适用于请求方法“PUT”，“POST”和“PATCH”
    let data = method === 'POST' || method === 'PUT' ? params : null;
    // `params`是要与请求一起发送的URL参数
    // 必须是纯对象或URLSearchParams对象
    let param = method === 'GET' || method === 'DELETE' ? params : null;
    //执行axios请求
    let $axios = axios.create()
    let config = {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }
    return $axios({
      method: method,
      url: url,
      // `data`是要作为请求主体发送的数据
      // 仅适用于请求方法“PUT”，“POST”和“PATCH”
      data: data,
      config,
      // `params`是要与请求一起发送的URL参数
      // 必须是纯对象或URLSearchParams对象
      params: param,
      // `baseURL`将被添加到`url`前面，除非`url`是绝对的。
      // 可以方便地为 axios 的实例设置`baseURL`，以便将相对 URL 传递给该实例的方法。
      baseURL: base,
      timeout: 30000,
      withCredentials: true // 是否跨域
    })
  }).then(function(res) {
    if (!res || !res.data || typeof res.data !== 'object' || res.data.code == null) throw new Error('Invalid server response')
    if (typeof res.data.data === 'string' && res.data.data !== '') {
      //参数解密
      res["\x64\x61\x74\x61"]["\x64\x61\x74\x61"] = JSON["\x70\x61\x72\x73\x65"](common["\x64\x65\x63\x72\x79\x70\x74\x65\x64\x42\x79\x41\x45\x53"](res["\x64\x61\x74\x61"]["\x64\x61\x74\x61"],'\x38\x39\x30\x33\x38\x32\x38\x41\x38\x31\x45\x42\x34\x39\x42\x33\x39\x41\x34\x42\x33\x45\x35\x39\x39\x42\x31\x38\x39\x32\x43\x33'))
    }
    return res
  }).then(function(res) {
    // Business callback errors are not transport failures and must not unlock
    // an already accepted withdrawal by invoking failure a second time.
    return typeof callback === 'function' ? callback(res) : res
  }, function(err) {
    const response = err && err.response
    const body = response && response.data
    const message = (body && (body.msg || body.message)) ||
      (err && err.message) || (response && response.statusText) || 'Network request failed'
    const error = { code: (response && response.status) || (err && err.code) || 0, message, msg: message }
    if (typeof failure === 'function') return failure(error)
    return null
  })
}
//抛出未知的错误
function tip(e) {
  if (e) {
    return e.message
  } else {
    console.log('unknown error')
  }
}

export default {
  get: function(url, params, callback, failure) {
    return apiAxios('GET', url, params, callback, failure)
  },
  post: function(url, params, callback, failure) {
    return apiAxios('POST', url, params, callback, failure)
  },
  put: function(url, params, callback, failure) {
    return apiAxios('PUT', url, params, callback, failure)
  },
  delete: function(url, params, callback, failure) {
    return apiAxios('DELETE', url, params, callback, failure)
  },
  tip: tip
}



// WEBPACK FOOTER //
// ./src/common/axios/index.js